import { supabase } from '../../../lib/supabase'
import type { RoomRow } from '../../../lib/database.types'

/**
 * Returns the caller's current matchmade IET room if one exists
 * (lobby/playing through to voting), otherwise null. Mirrors
 * `fetchMyMatchmadeColorfulRoom` for the Colorful flow.
 */
export async function fetchMyMatchmadeIETRoom(): Promise<RoomRow | null> {
  // Call directly — the function is now declared in
  // database.types.ts so the typed signature works without
  // re-binding (the unbinding cast trick was throwing
  // "undefined is not an object (evaluating 'this.rest')" on
  // newer @supabase/supabase-js).
  const { data, error } = await supabase.rpc('my_matchmade_iet_room', {})
  if (error) throw error
  const row = data as RoomRow | null
  if (!row || !row.id) return null
  return row
}
